import * as React from "react"

const SvgAlertCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.882q-.4 0-.762-.15a2.3 2.3 0 0 1-.663-.425L2.55 14.282q-.275-.3-.425-.662t-.15-.763.15-.775.425-.65l8.025-8.025q.3-.3.663-.437.361-.138.762-.138c.401 0 .525.046.775.138q.375.137.65.437l8.025 8.025q.3.275.438.65a2.23 2.23 0 0 1 0 1.538 1.9 1.9 0 0 1-.438.662l-8.025 8.025a1.9 1.9 0 0 1-.65.425q-.375.15-.775.15m0-2 8.025-8.025L12 4.832l-8.025 8.025zm0-7.025q.424 0 .713-.287a.97.97 0 0 0 .287-.713v-4a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712v4q0 .426.288.713a.97.97 0 0 0 .712.287m0 3q.424 0 .713-.287a.97.97 0 0 0 .287-.713.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712q0 .425.288.713a.97.97 0 0 0 .712.287" />
  </svg>
)
export default SvgAlertCircle
